import { fetchClient } from "@/api/api";
import type {
	getAdminComfortTradeSendersInput,
	getAdminComfortTradeSendersOutput,
} from "@/api/custom_types";
import type { CustomQueryHook } from "@/utils/react-query";
import { useQuery } from "@tanstack/react-query";
import { ADMIN_COMFORT_TRADE_SENDERS_SERVICE_KEYS } from "./keys";

export const useGetAdminComfortTradeSenders: CustomQueryHook<
	getAdminComfortTradeSendersOutput,
	getAdminComfortTradeSendersInput
> = (payload, options) => {
	return useQuery({
		...options,
		queryKey:
			ADMIN_COMFORT_TRADE_SENDERS_SERVICE_KEYS.useGetAdminComfortTradeSenders(
				payload,
			),
		queryFn: async () => {
			const { data, error } = await fetchClient.GET(
				"/v1/fc/admin/comfort-trade-senders/",
				{
					params: { query: payload },
					throwOnError: true,
				},
			);
			if (error) throw error;
			return data;
		},
	});
};
